import { Banner, type BannerProps } from "@src/appV2/redesign/system/ui-components";

export const DOCUMENTS_UNLOCK_BANNER_VARIANTS = ["mandatory", "workplaceSpecific"] as const;
export type DocumentsUnlockBannerVariant = (typeof DOCUMENTS_UNLOCK_BANNER_VARIANTS)[number];

export interface DocumentsUnlockBannerProps {
  variant: DocumentsUnlockBannerVariant;
  children?: React.ReactNode;
  onClose: () => void;
}

export const VARIANT_MAP: Record<DocumentsUnlockBannerVariant, Omit<BannerProps, "onClose">> = {
  workplaceSpecific: {
    illustrationType: "facility-small",
    title: "Unlock more Flex Shifts at workplaces",
    description:
      "Complete additional documents required by certain workplaces so you can book more shifts.",
  },
  mandatory: {
    illustrationType: "unlock-small",
    title: "Mandatory documents for Flex Shifts",
    description: "The below documents are required to work shifts at all workplaces in your area",
  },
};

export function DocumentsUnlockBanner(props: DocumentsUnlockBannerProps) {
  const { variant, children, onClose } = props;

  return (
    <Banner
      illustrationType={VARIANT_MAP[variant].illustrationType}
      title={VARIANT_MAP[variant].title}
      description={VARIANT_MAP[variant].description}
      onClose={onClose}
    >
      {children}
    </Banner>
  );
}
